import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import type { ReactElement } from 'react'
import { AppShell } from './components/AppShell'
import { useAuth } from './auth/useAuth'
import { DailyReportDetailPage } from './pages/DailyReportDetailPage'
import { DailyReportsPage } from './pages/DailyReportsPage'
import { DashboardPage } from './pages/DashboardPage'
import { DrawingEntryPage } from './pages/DrawingEntryPage'
import { LabourEntryPage } from './pages/LabourEntryPage'
import { MaterialEntryPage } from './pages/MaterialEntryPage'
import { WorkEntryPage } from './pages/WorkEntryPage'
import { PendingDrawingsPage } from './pages/PendingDrawingsPage'
import { LoginPage } from './pages/LoginPage'
import { MaterialsPage } from './pages/MaterialsPage'
import { ProfilePage } from './pages/ProfilePage'
import { ProjectsPage } from './pages/ProjectsPage'
import { ReferencePage } from './pages/ReferencePage'
import { RolesPage } from './pages/admin/RolesPage'
import { NetworkPage } from './pages/NetworkPage'
import { SitesPage } from './pages/SitesPage'
import { WorkItemsPage } from './pages/WorkItemsPage'
import { TemplatesPage } from './pages/TemplatesPage'
import { UsersPage } from './pages/admin/UsersPage'

function RequireAuth({ children }: { children: ReactElement }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    )
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  return children
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/daily-reports" element={<DailyReportsPage />} />
        <Route path="/daily-reports/:id" element={<DailyReportDetailPage />} />
        <Route path="/entry/work" element={<WorkEntryPage />} />
        <Route path="/entry/labour" element={<LabourEntryPage />} />
        <Route path="/entry/material" element={<MaterialEntryPage />} />
        <Route path="/entry/drawings" element={<DrawingEntryPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/programme" element={<NetworkPage />} />
        <Route path="/drawings/pending" element={<PendingDrawingsPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/sites" element={<SitesPage />} />
        <Route path="/site-boq" element={<WorkItemsPage />} />
        <Route path="/materials" element={<MaterialsPage />} />
        <Route path="/reference" element={<ReferencePage />} />
        <Route path="/admin/users" element={<UsersPage />} />
        <Route path="/admin/roles" element={<RolesPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
